if (!customElements.get("main-collection-2-infinite-scroll-loader")) {
  class MainCollection2InfiniteScrollLoader extends HTMLElement {
    constructor() {
      super();
      
      this.page = 2;
      this.totalPages = null;
      this.productCountInProductGrid = 0;
      this.observer = null;
      this.isLoading = false;
      
      this.prefetchedHTML = null;
      this.prefetchPromise = null;
      
      this.handleReset = this.handleReset.bind(this);
    }
    
    connectedCallback() {
      this.init();
    }
    
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener("main-collection-2:infinite-scroll:reset", this.handleReset);
    }
    
    init() {
      this.updateTotalPages();
      this.productCountInProductGrid = Number(this.dataset.productNodesCount) || 0;
      this.grid = document.getElementById("product-grid");
      

      const config = {
        rootMargin: `0px 0px ${window.innerHeight * 2.5}px 0px`,
        threshold: 0
      };
      
      this.observer = new IntersectionObserver(entries => {
        if (!entries[0].isIntersecting) return;
        if (this.isLoading) return;
        
        this.isLoading = true;
        this.observer.unobserve(this);
        this.loadMoreProducts();
      }, config);
      
      this.observer.observe(this);
      
      document.addEventListener("pointerdown", () => { this.prefetchNextPage(); }, { once: true, passive: true });
      document.addEventListener("main-collection-2:infinite-scroll:reset", this.handleReset)
    }

    updateTotalPages(){
      this.totalPages = this.dataset.pages ? Number(this.dataset.pages): 2;
    }

    handleReset() {
      this.style.display = "block";
      this.classList.add("!tw-block");
      this.page = 2;
      this.updateTotalPages();
      this.productCount = document.getElementById("product-grid")?.querySelectorAll(".product-card-2__wrapper").length || 0;
      this.prefetchedHTML = null;
      this.prefetchPromise = null;

      this.observer?.unobserve(this);
      this.observer?.observe(this);
      console.log(this.page, this.totalPages, this.productCount);
    }

    async loadMoreProducts() {
      let hasProducts = false;

      try {
        if (!this.grid) return;
        const section_id = this.grid.dataset.id;

        const params = new URLSearchParams(window.location.search);
        params.set("page", this.page);
        params.set("section_id", section_id);
        const url = `${window.location.pathname}?${params.toString()}`;

        if (this.prefetchPromise) {
          await this.prefetchPromise;
        }
        let html = this.prefetchedHTML;

        if (!html){
          const response = await fetch(url);
          html = await response.text();
        }
        this.page += 1;

        const temp = document.createElement('div');
        temp.innerHTML = html;

        const tempGrid = temp.querySelector('#product-grid');
        
        if (!tempGrid) return
        
        const tempLoader = temp.querySelector("main-collection-2-infinite-scroll-loader");
        if (tempLoader){
          const count = Number(tempLoader.dataset.productNodesCount) || 0;
          this.productCountInProductGrid += count;
        }

        const newGridItems = tempGrid.children;
        const fragment = document.createDocumentFragment();
        hasProducts = [...newGridItems].some(item => item?.classList.contains("product-card-2__wrapper"));
        if (!hasProducts) return;

        [...newGridItems].forEach((item) => {
          if (item.classList.contains("product-card-2__wrapper")) {
            fragment.appendChild(item);
          }
        });

        requestAnimationFrame(() => {
          this.grid.appendChild(fragment);
          this.prefetchedHTML = null;
          this.prefetchPromise = null;
          this.prefetchNextPage();

          setTimeout(() => {
            if (typeof HulkappWishlist !== 'undefined' && HulkappWishlist) {
              HulkappWishlist._manageCollectionWL();

              allHulkWishlistButtons = Array.from(document.querySelectorAll('[data-wishlist]'));
              HulkappWishlist._checkForProductStatus(allHulkWishlistButtons, 'multiple');
            }  
          }, 1500);

          document.dispatchEvent(new CustomEvent('main-collection-2:inline-filter-visibility:update', {
            detail: {
              data: {
                productsCount: this.productCountInProductGrid
              }
            }
          }));
          document.dispatchEvent(new CustomEvent('main-collection-2:inline-promotion-images-visibility:update', {
            detail: {
              data: {
                productsCount: this.productCountInProductGrid
              }
            }
          }));
        });


      } catch (error) {
        console.log("main-collection-2-infinite-scroll.js:Error: ", error);
      } finally {
        this.isLoading = false;
        if (hasProducts) {
          this.observer.observe(this);
        } else if (!hasProducts && this.totalPages >= this.page){
          this.prefetchedHTML = null;
          this.prefetchPromise = null;
          this.observer.observe(this);
          this.prefetchNextPage();
        } else if (!hasProducts && this.totalPages < this.page) {
          this.observer.unobserve(this);
          this.classList.remove("!tw-block");
          this.style.display = "none";
        }
      }
    }

    async prefetchNextPage() {
      if (this.prefetchPromise) return;

      const grid = document.getElementById("product-grid");
      if (!grid) return;

      const section_id = grid.dataset.id;

      const params = new URLSearchParams(window.location.search);

      params.set("page", this.page);
      params.set("section_id", section_id);

      const url = `${window.location.pathname}?${params}`;

      this.prefetchPromise = fetch(url)
        .then(res => res.text())
        .then(html => {
          this.prefetchedHTML = html;
        })
        .catch(() => {
          this.prefetchedHTML = null;
        });
    }

  }

  customElements.define("main-collection-2-infinite-scroll-loader", MainCollection2InfiniteScrollLoader);
}